<template>
  <div>
    <el-descriptions :column="4">
      <el-descriptions-item label="YS销售单号">
        {{ detail.cthirdOrderCode }}
      </el-descriptions-item>
      <el-descriptions-item label="出货日期">
        {{ detail.tout }}
      </el-descriptions-item>
      <el-descriptions-item label="客户名称">
        <template v-for="(item) in channelOptions">
          <template v-if="detail.rchannel.includes(item.code)">
            {{ item.name }}
          </template>
        </template>
      </el-descriptions-item>
      <el-descriptions-item label="门店编号">
        {{ detail.cstore }}
      </el-descriptions-item>
      <el-descriptions-item label="门店名称">
        {{ detail.sstore }}
      </el-descriptions-item>
      <el-descriptions-item label="财务关系">
        <template v-for="(item) in financialOptions">
          <template v-if="detail.cfinance.includes(item.id)">
            {{ item.name }}
          </template>
        </template>
      </el-descriptions-item>
      <el-descriptions-item label="同步状态">
        <div v-if="detail.bstatus === 1" style="color: blue">
          等待同步
        </div>
        <div v-else-if="detail.bstatus === 3" style="color: red">
          同步失败
        </div>
        <div v-else style="color: green">
          同步成功
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="同步时间">
        {{ detail.tsync | time }}
      </el-descriptions-item>
    </el-descriptions>
    <el-input v-model="search" class="search-input" clearable placeholder="请输入关键字查询" size="mini" @keyup.enter.native="handleSearch">
      <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
    </el-input>
    <el-table v-loading="loading" :data="detailList"  element-loading-spinner="el-icon-loading" :element-loading-text="loadingMsg"
              height="calc(70vh - 200px)">
      <el-table-column label="序号" align="center" type="index" />
      <el-table-column label="图片" align="center" >
        <template #default="scope">
          <el-image :preview-src-list="[scope.row.cmasterUrl]" class="w50 h50" :src="scope.row.cmasterUrl"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="SKU" align="center" prop="csku" />
      <el-table-column label="条形码" align="center" prop="cbarcode" />
      <el-table-column label="货品名称" align="center" prop="sgoods" />
      <el-table-column label="数量" align="center" prop="nout" sortable/>
      <el-table-column label="单价" align="center" prop="nprice" sortable/>
      <el-table-column label="金额" align="center" prop="namount" sortable/>
    </el-table>
    <div class="dialog-footer">
      <span>共计  {{ detailList.length }}  种货品</span>
      <div class="dialog-footer-tail">
        <el-button type="primary" plain @click="handleSync" :loading="loading" :disabled="detail.bstatus === 1 || detail.bstatus === 2">
          <span>同步到YS</span>
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">若单据状态为同步失败，可再次推送，否则不能推送</div>
            <i class="el-icon-question" style="margin-left: 5px"></i>
          </el-tooltip>
        </el-button>
        <el-button type="primary" plain @click="modalClose">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {ordPickingSettleDetail, ordPickingSettleDetailList, ordPickingSettleSync} from "@/api/store/ordPicking";
import {formatTime} from "@/utils/utils";

export default {
  name: "OrderPickingSettleDetail",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    channelOptions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    financialOptions: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {
      sid: undefined,
      detail: {},
      detailList: [],
      originList: [],
      loading: false,
      loadingMsg: "",
      search: undefined
    }
  },
  filters: {
    time(value) {
      if (value) {
        return formatTime(value);
      }
    }
  },
  methods: {
    getData(sid) {
      this.sid = sid
      this.getDetail()
    },
    getDetail() {
      ordPickingSettleDetail(this.sid).then((res) => {
        this.detail = res.data;
        this.getDetailList();
      })
    },
    getDetailList() {
      this.loading = true;
      ordPickingSettleDetailList({ settleId: this.sid }).then((res) => {
        this.detailList = res.data;
        this.originList = res.data;
        this.loading = false;
      })
    },
    handleSearch() {
      this.loading = true
      if (this.search) {
        this.search = this.search.split(' ').join('')
        this.detailList = this.originList.filter(
          item => item.csku.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            || item.cbarcode.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            || item.sgoods.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        )
      } else {
        this.detailList = this.originList
      }
      this.loading = false
    },
    modalClose() {
      this.$emit('update:visible', false)
    },
    changeNotify() {
      this.$emit("ref", true);
    },
    handleSync() {
      this.loading = true;
      this.loadingMsg = "正在同步到YS,请耐心等候...";
      ordPickingSettleSync([this.sid]).then(() => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.getDetail();
        this.changeNotify();
        this.loading = false;
        this.loadingMsg = "";
      }).catch(() => {
        this.loading = false;
        this.loadingMsg = "";
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search-input {
  width: 250px;
}
.dialog-footer {
  margin-top: 10px;
  margin-bottom: 10px;
}
.dialog-footer-tail {
  float: right;
}
</style>
